export default {
      id: "settings-usage",
      viewBox: "0 0 291.58 283.55",
      url: __webpack_public_path__ + "live-atlas/img/icons.e641665a.svg#settings",
      toString: function () {
        return this.url;
      }
    }